import request from '@/utils/request'
// import qs from 'qs'

// 动态列表
export const pageList = (getData) => {
  return request({
    url: '/back/maintenance/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 状态改变
export const updateStatus = (getData) => {
  return request({
    url: '/back/maintenance/updateStatus',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 上传附件
export const uploadFile = (postData) => {
  return request({
    url: '/back/maintenance/upload',
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data'
    },
    data: postData
  })
}
// 修改附件
export const uploadUrl = (getData) => {
  return request({
    url: '/back/maintenance/updatePath',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除动态
export const deleteById = (getData) => {
  return request({
    url: '/back/maintenance/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改动态
export const updateById = (postData) => {
  return request({
    url: '/back/maintenance/updateMaintenanceTips',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 保存动态
export const addAdvertise = (postData) => {
  return request({
    url: '/back/maintenance/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
